import React, { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { delay } from 'lodash-es'
import { useLocation, useNavigate } from 'react-router-dom'
import { PathNames } from 'constants/General'
import { deleteChatbotCookie, deleteProfileCookie, HALF_SECOND } from 'utils/utils'

const Logout = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { state } = useLocation() || {}

  const resetCookiesSession = () => {
    deleteProfileCookie()
    deleteChatbotCookie()
  }

  const resetReactQuery = async () => {
    await queryClient.cancelQueries()
    queryClient.clear()
  }

  useEffect(() => {
    delay(async () => {
      await resetReactQuery()
      resetCookiesSession()
      navigate(PathNames.LOGIN, { replace: true, state })
    }, HALF_SECOND)
  }, [])

  return <></>
}

export default Logout
